import { useState } from 'react';
import { Modal } from './Modal';

const TZS = ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Phoenix', 'America/Los_Angeles', 'America/Anchorage', 'Pacific/Honolulu'];

export function CallbackScheduler({ defaultTz, onCancel, onSubmit }: { defaultTz?: string; onCancel: () => void; onSubmit: (b: { at: number; only_me: boolean; tz: string; comments: string }) => void }) {
  const d = new Date(Date.now() + 60 * 60 * 1000);
  const [date, setDate] = useState(d.toISOString().slice(0, 10));
  const [time, setTime] = useState(`${String(d.getHours()).padStart(2, '0')}:00`);
  const [tz, setTz] = useState(defaultTz ?? Intl.DateTimeFormat().resolvedOptions().timeZone);
  const [onlyMe, setOnlyMe] = useState(false);
  const [comments, setComments] = useState('');
  const at = () => {
    // Interpret date+time in the chosen zone by asking the formatter for that zone's offset.
    const local = new Date(`${date}T${time}:00`);
    const asIf = new Date(local.toLocaleString('en-US', { timeZone: tz }));
    return local.getTime() + (local.getTime() - asIf.getTime());
  };
  return (
    <Modal id="CallBackSelectBox" title="Schedule Callback" onClose={onCancel}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
        <div><label>Date</label><input type="date" value={date} onChange={(e) => setDate(e.target.value)} /></div>
        <div><label>Time</label><input type="time" value={time} onChange={(e) => setTime(e.target.value)} /></div>
        <div><label>Time zone</label><select value={tz} onChange={(e) => setTz(e.target.value)}>{[tz, ...TZS.filter((z) => z !== tz)].map((z) => <option key={z}>{z}</option>)}</select></div>
      </div>
      <label className="check" style={{ marginTop: 10 }}><input id="CallBackOnlyMe" type="checkbox" checked={onlyMe} onChange={(e) => setOnlyMe(e.target.checked)} /> Only me (USERONLY)</label>
      <div style={{ marginTop: 10 }}><label>Comments</label><textarea rows={2} value={comments} onChange={(e) => setComments(e.target.value)} /></div>
      <div className="actions">
        <button onClick={onCancel}>Back</button>
        <button className="primary" onClick={() => onSubmit({ at: at(), only_me: onlyMe, tz, comments })}>Submit</button>
      </div>
    </Modal>
  );
}
